import React from 'react';
import { Page } from '../Page';
import { Beef, Leaf, Wheat, Utensils, SlidersHorizontal, CheckCircle2, TrendingUp, Info } from 'lucide-react';
export function Page5() {
  return <Page pageNumber={23} variant="light" data-id="element-720">
      <div className="flex flex-col h-full" data-id="element-721">
        <div className="mb-6 pt-2" data-id="element-722">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-723">
            The Essentials
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-724">
            How to <span className="text-tealslate" data-id="element-725">Plate a Meal</span>
          </h1>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-726">
            When you don't want to track numbers, use the plate method.
          </p>
        </div>

        {/* Plate diagram on light bg */}
        <div className="flex justify-center items-center mb-6" data-id="element-727">
          <div className="w-[140px] space-y-4 text-right pr-4" data-id="element-728">
            <div data-id="element-729">
              <h3 className="text-tealslate font-bold text-xs uppercase tracking-wider" data-id="element-730">
                Protein
              </h3>
              <p className="text-[9px] text-[#7A7A70]" data-id="element-731">
                Chicken, fish, eggs, tofu, lean beef
              </p>
            </div>
          </div>

          <div className="w-[260px] h-[260px] rounded-full shadow-lg relative border-[6px] border-[#D8D8D0] shrink-0" style={{
          background: 'conic-gradient(from 270deg, #8FADB8 0deg 180deg, #B8C5B4 180deg 270deg, #D4C9A8 270deg 360deg)'
        }} data-id="element-732">
            <div className="absolute inset-3 rounded-full border border-white/40 pointer-events-none" data-id="element-733" />
            <div className="absolute top-0 bottom-0 left-1/2 w-px bg-white/50 -translate-x-1/2" data-id="element-734" />
            <div className="absolute top-1/2 bottom-0 left-1/2 right-0 h-px bg-white/50 -translate-y-1/2" data-id="element-735" />

            <div className="absolute top-0 bottom-0 left-0 w-1/2 flex flex-col items-center justify-center text-center" data-id="element-736">
              <Beef className="w-7 h-7 text-white/90 mb-1" data-id="element-737" />
              <span className="text-2xl font-serif text-white font-bold" data-id="element-738">
                1/2
              </span>
              <span className="text-[8px] font-bold text-white uppercase tracking-wider" data-id="element-739">
                Protein
              </span>
            </div>
            <div className="absolute top-0 right-0 w-1/2 h-1/2 flex flex-col items-center justify-center text-center" data-id="element-740">
              <Leaf className="w-5 h-5 text-white/90 mb-0.5" data-id="element-741" />
              <span className="text-lg font-serif text-white font-bold" data-id="element-742">
                1/4
              </span>
              <span className="text-[7px] font-bold text-white uppercase" data-id="element-743">
                Veggies
              </span>
            </div>
            <div className="absolute bottom-0 right-0 w-1/2 h-1/2 flex flex-col items-center justify-center text-center" data-id="element-744">
              <Wheat className="w-5 h-5 text-white/90 mb-0.5" data-id="element-745" />
              <span className="text-lg font-serif text-white font-bold" data-id="element-746">
                1/4
              </span>
              <span className="text-[7px] font-bold text-white uppercase" data-id="element-747">
                Carbs
              </span>
            </div>
          </div>

          <div className="w-[140px] space-y-4 pl-4" data-id="element-748">
            <div data-id="element-749">
              <h3 className="text-tealslate font-bold text-xs uppercase tracking-wider" data-id="element-750">
                Vegetables
              </h3>
              <p className="text-[9px] text-[#7A7A70]" data-id="element-751">
                Leafy greens, broccoli, peppers
              </p>
            </div>
            <div data-id="element-752">
              <h3 className="text-tealslate font-bold text-xs uppercase tracking-wider" data-id="element-753">
                Carbs
              </h3>
              <p className="text-[9px] text-[#7A7A70]" data-id="element-754">
                Brown rice, quinoa, sweet potato
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-755">
          <Info className="w-3.5 h-3.5 text-tealslate" data-id="element-756" />
          <p className="text-[10px] text-[#7A7A70]" data-id="element-757">
            <strong className="text-[#3B3B3B]" data-id="element-758">Note:</strong> Starchy vegetables
            count in the carbohydrate category.
          </p>
        </div>

        {/* Quick Tips */}
        <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-759">
          <h3 className="text-center text-[10px] font-bold text-tealslate uppercase tracking-[0.15em] mb-3" data-id="element-760">
            Quick Tips
          </h3>
          <div className="grid grid-cols-4 gap-3" data-id="element-761">
            {[{
            icon: Utensils,
            text: 'Eat protein first'
          }, {
            icon: SlidersHorizontal,
            text: 'Adjust portions to goals'
          }, {
            icon: CheckCircle2,
            text: 'Keep it simple'
          }, {
            icon: TrendingUp,
            text: 'Progress over perfection'
          }].map((tip, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-762">
                <div className="w-8 h-8 rounded-full bg-tealslate/20 flex items-center justify-center mb-2" data-id="element-763">
                  <tip.icon className="w-4 h-4 text-tealslate" data-id="element-764" />
                </div>
                <p className="text-[9px] text-[#3B3B3B] font-medium leading-tight" data-id="element-765">
                  {tip.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </Page>;
}